import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * MM-1207: the zone AppointmentVO.scheduledTime is written in (ehr-service DateUtility.dateToString,
 * MindwealConstants.TIMEZONE_CST).
 */
const OFFICE_TIME_ZONE = 'America/Chicago';

/**
 * MM-1207: AppointmentVO.scheduledTime (from ehr-service) is a bare office-local wall-clock string
 * with no offset - "2026-09-24T10:00:00" for a 10am Chicago appointment. It is read as Chicago time
 * and converted to the patient's browser time zone, so the day and time match the patient
 * dashboard and Appointment History.
 */
const toLocalAppointmentTime = (scheduledTime: string) => dayjs.tz(scheduledTime, OFFICE_TIME_ZONE).local();

/**
 * MM-1207: the real appointment moment, so the reschedule/cancel window and the Join button are
 * not shifted by the Chicago UTC offset.
 */
export const asAppointmentDate = (scheduledTime: string) => toLocalAppointmentTime(scheduledTime).toDate();

/**
 * MM-1207: the appointment day in the patient's browser time zone.
 */
export const formatAppointmentDay = (scheduledTime: string): string =>
  toLocalAppointmentTime(scheduledTime).format('dddd, MMMM D, YYYY');

/**
 * MM-1207: the appointment start and end time in the patient's browser time zone.
 */
export const formatAppointmentTimeRange = (scheduledTime: string, durationMinutes: number) => {
  const start = toLocalAppointmentTime(scheduledTime);
  const end = start.add(durationMinutes || 0, 'minute');
  const sameMeridiem = start.format('A') === end.format('A');
  return {
    startTime: start.format(sameMeridiem ? 'h:mm' : 'h:mm A'),
    endTime: end.format('h:mm A'),
  };
};
